// @ts-nocheck

import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';

import { useWtv } from '../../hooks';

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
`;

type FloatingWtvPlaceholderProps = {
  className?: string;
};

/**
 * @param {string} className set a custom className and allow styled components to apply CSS styles correctly
 *
 * @return {Node} The placeholder which holds the Winamax TV
 */
const FloatingWtvPlaceholder = ({ className }: FloatingWtvPlaceholderProps) => {
  const ref = useRef();
  const { setPlaceholderRef } = useWtv();

  useEffect(() => {
    if (ref.current) {
      setPlaceholderRef(ref);
    }
  }, [setPlaceholderRef]);

  return <Wrapper data-testid="floating-wtv" className={className} ref={ref} />;
};

export default FloatingWtvPlaceholder;
